// extracted by mini-css-extract-plugin
export default {"col":"Medicine_col__SZTtX","med_div":"Medicine_med_div__yJ4ux"};